module.exports = __webpack_public_path__ + "assets/media/video-convo.1874d969.jpg";